import { Box, styled } from '@mui/material';

const GridHeader = styled(Box)`
  display: flex;
  margin-bottom: 24px;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  h3 {
    margin: 0;
  }
`;

export default GridHeader;
